import type { AccessPair } from '@/shared/lib'

/**
 * `/v1/exchange/**` — наблюдение за обменом с 1С. Маршрут закрыт правом `exchange.view`.
 * Модификатора «от имени» у ресурса нет: `?client=`/`account`/`unp`/`settlement`/`cart` все
 * ручки отвергают `400 acting.not-supported`, поэтому `onBehalf`/`accepts` в паре не заданы.
 */
export const EXCHANGE_ACCESS: AccessPair = { own: 'exchange.view' }
